<template>
  <b-modal
    id="updateReward"
    size="md"
    centered
    :hide-header="true"
    :hide-footer="true"
    content-class="p-2 atm-rounded"
    no-close-on-backdrop
  >
    <h3 class="mb-3">Edit Reward</h3>
    <div class="px-3">
      <div class="d-flex gap-4 flex-column justify-items-center mb-4">
        <input
          type="text"
          v-model="rewardData.name"
          class="atm-input-title font-weight-600 mb-3"
          placeholder="Reward Title"
          required
        />
        <input
          type="number"
          v-model="rewardData.coins_required"
          class="atm-input"
          placeholder="Coins"
          required
        />
        <div class="d-flex align-items-center ml-3">
          <input id="reUse" v-model="rewardData.re_use" type="checkbox" class="atm-input-checkbox" />
          <label for="reUse" class="material-icons-round ml-0"></label>
          <label class="m-0">Allow reuse of this reward</label>
        </div>
      </div>
      <div class="d-flex gap-4 justify-content-center align-items-center">
        <button
          class="atm-button flex-grow-1 bg-gray text-dark font-weight-bold w-50"
          @click="hideUpdateRewardModal"
        >
          Cancel
        </button>
        <button
          class="atm-button flex-grow-1 bg-main font-weight-bold w-50"
          @click="editReward()"
        >
          Edit Reward
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
  props: {
    rewardData: { type: Object, default: () => {} },
  },
  methods: {
    hideUpdateRewardModal() {
      this.$bvModal.hide('updateReward');
    },
    async editReward() {
      const rewardDataToBeEdited = {
        reward_id: this.rewardData.id,
        data: {
          ...this.rewardData,
        },
      };
      this.$emit('updateReward', { rewardDataToBeEdited });
      this.hideUpdateRewardModal();
    },
  },
};
</script>

